import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';
import { InputGroup, FormControl } from 'react-bootstrap';

class Paginator extends Component {

    componentDidMount() {
        const { currentPage, pageSize } = this.props.pagination; 
        this.props.getJobDetails({ currentPage, pageSize});
    }

    onPaginate(currentPage, pageSize) {
        const params = { currentPage, pageSize };
        this.props.getJobDetails(params);
    }

    render() {
        const { currentPage, pagesCount, itemsCount, pageSize } = this.props.pagination;
        return (itemsCount > 0) &&
            <div className="col-md-4" style={{ "marginTop": "1%" }}>
                <div className="row">
                    <div className="col-md-6">
                        <nav aria-label="Page navigation example">
                            <ul className="pagination">

                                {/* FIRST */}
                                <li className={"page-item" + (currentPage <= 1 ? " disabled" : "")}>
                                    <Link to="#" className="page-link" onClick={() => this.onPaginate(1, pageSize)}>
                                        <span aria-hidden="true">&laquo;</span>
                                    </Link>
                                </li>

                                {/* PREVIOS */}
                                {
                                    currentPage > 1 &&
                                    <li className="page-item">
                                        <Link to="#" className="page-link" onClick={() => this.onPaginate(currentPage - 1, pageSize)}>{currentPage - 1}</Link>
                                    </li>
                                }

                                {/* CURRENT */}
                                <li className="page-item active">
                                    <Link to="#" className="page-link">{currentPage} <span className="sr-only">(current)</span></Link>
                                </li>

                                {/* NEXT */}
                                {
                                    currentPage < pagesCount &&
                                    <li className="page-item">
                                        <Link to="#" className="page-link" onClick={() => this.onPaginate(currentPage + 1, pageSize)}>{currentPage + 1}</Link>
                                    </li>
                                }

                                {/* LAST */}
                                <li className={"page-item" + (currentPage >= pagesCount ? " disabled" : "")}>
                                    <Link to="#" className="page-link" onClick={() => this.onPaginate(pagesCount, pageSize)}>
                                        <span aria-hidden="true">&raquo;</span>
                                        <span className="sr-only">Last</span>
                                    </Link>
                                </li>
                            </ul>
                        </nav >
                    </div>
                    <div className="col-md-6">
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>Size</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl         
                                aria-label="Default"
                                aria-describedby="inputGroup-sizing-default"
                                placeholder="PageSize"
                                value={pageSize}
                                onChange={e => this.onPaginate(1, e.target.value)}
                            />  
                            <InputGroup.Append>
                                <InputGroup.Text>{itemsCount}</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                    </div>
                </div>
            </div >
    }
}
     
// Paginator.propTypes = {
//     getTradeRules: PropTypes.func.isRequired,
//     pagination: PropTypes.object.isRequired
// };

export default Paginator;